import { InitPageStrict } from "../index";
import swal from "sweetalert";

class ReplenishmentTemplatesShow {
  private readonly exportModalSelector = "#replenishment-template-export-dialog";
  private readonly massUpdateModalSelector = "#replenishment-template-mass-update-dialog";
  private readonly massUpdateFormSelector = "#replenishment_template_mass_update_form";
  private readonly autoUpdateRulesModalSelector = "#replenishment-template-auto-update-rules-dialog";
  private readonly itemModalSelector = "#replenishment-template-item-dialog";
  private readonly reprocessRulesModalSelector = "#replenishment-template-reprocess-rules-dialog";
  private readonly reprocessRulesFormSelector = "#replenishment_template_reprocess_rules_form";
  private itemRow: JQuery | null = null;
  private massUpdateFilterMaxIndex = 0;
  private autoUpdateRuleConditionMaxIndex = 0;
  private readonly autoUpdateRuleDefaultCriteria = "equals";

  constructor() {
    this.dismissFlashMessages();
    this.bindEvents();
    this.bindMassUpdate();
    this.bindAutoUpdateRules();
    this.bindTemplateItemQuantities();
  }

  private dismissFlashMessages(): void {
    setTimeout(() => {
      $(".alert.alert-success.fade.in, .alert.alert-warning.fade.in, .alert.alert-danger.fade.in").each(function () {
        $(this).fadeOut(300, function () {
          $(this).remove();
        });
      });
    }, 2000);
  }

  private bindEvents(): void {
    $(document).on("click", ".export-button", (e) => {
      e.preventDefault();
      $(this.exportModalSelector).modal("show");
    });

    $(document).on("click", ".mass-update-button", (e) => {
      e.preventDefault();
      $(this.massUpdateModalSelector).modal("show");
    });

    $(document).on("click", ".reprocess-rules-button", (e) => {
      e.preventDefault();
      $(this.reprocessRulesModalSelector).modal("show");
    });

    $(document).on("submit", this.reprocessRulesFormSelector, (e) => {
      $(e.currentTarget).find("button[type='submit']").prop("disabled", true);
    });
  }

  private bindTemplateItemQuantities(): void {
    const modal = this.itemModalSelector;

    $(document).on("click", ".template-item-edit-trigger", (e) => {
      e.preventDefault();

      const $row = $(e.currentTarget).closest(".template-item-row");
      this.itemRow = $row;

      $("#template_item_number").text(this.displayValue($row.data("itemNumber")));
      $("#template_item_description").text(this.displayValue($row.data("description")));
      $("#template_item_min_qty").val($row.find(".template-item-min").text().trim());
      $("#template_item_max_qty").val($row.find(".template-item-max").text().trim());
      $("#template_item_error").hide().text("");

      $(modal).modal({ backdrop: "static", keyboard: false });
    });

    $(document).on("click", "#template_item_save", (e) => {
      e.preventDefault();

      const $row = this.itemRow;
      const url = $row ? ($row.data("updateUrl") as string) : "";
      if (!$row || !url) {
        return;
      }

      const $button = $(e.currentTarget);
      $button.prop("disabled", true);

      $.ajax({
        url: url,
        type: "PATCH",
        dataType: "json",
        data: {
          min_qty: $("#template_item_min_qty").val(),
          max_qty: $("#template_item_max_qty").val()
        },
        headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr("content") || "" }
      })
        .done((response: { min_qty?: number; max_qty?: number }) => {
          $row.find(".template-item-min").text(String(response.min_qty));
          $row.find(".template-item-max").text(String(response.max_qty));
          $(modal).modal("hide");
          window.toastr_notifications.success("Quantities updated.", "");
        })
        .fail((xhr: JQuery.jqXHR) => {
          const response = (xhr.responseJSON || {}) as { message?: string };
          $("#template_item_error").text(response.message || "Could not update the quantities.").show();
        })
        .always(() => {
          $button.prop("disabled", false);
        });
    });

    $(document).on("hidden.bs.modal", modal, () => {
      this.itemRow = null;
      $("#template_item_error").hide().text("");
    });
  }

  private displayValue(value: unknown): string {
    const text = value === undefined || value === null ? "" : String(value).trim();
    return text.length ? text : "\u2014";
  }

  private bindMassUpdate(): void {
    const modal = this.massUpdateModalSelector;
    const form = this.massUpdateFormSelector;

    $(document).on("change", `${modal} .rt-mass-update-toggle`, function (this: HTMLElement) {
      const targetId = $(this).data("target") as string;
      const $input = $(`#${targetId}`);
      const on = $(this).is(":checked");
      $input.prop("disabled", !on);
      $input.prop("required", on);
      if (!on) {
        $input.val("");
      }
    });

    $(document).on("click", `${modal} .mass-update-add-filter`, (e) => {
      e.preventDefault();
      const $rows = $("#mass-update-filter-rows");
      const $composer = $rows.find(".mass-update-filter-row-composer").first();
      if (!$composer.length) {
        return;
      }

      const $form = $(form);
      const addMsg = ($form.data("addFilterMessage") as string) || "";

      const $select = $composer.find("select.mass-update-filter-field");
      const $text = $composer.find("input[type='text']");
      const fieldVal = String($select.val() || "").trim();
      const textVal = String($text.val() || "").trim();

      if (!fieldVal || !textVal) {
        this.clearModalErrors(this.massUpdateModalSelector);
        if (!fieldVal) {
          this.showFieldError("#mass-update-filter-rows select.mass-update-filter-field", addMsg,
                              this.massUpdateModalSelector);
        } else {
          this.showFieldError("#mass-update-filter-rows .mass-update-filter-row-composer input[type='text']",
                              addMsg, this.massUpdateModalSelector);
        }
        return;
      }

      this.massUpdateFilterMaxIndex += 1;
      const newIx = this.massUpdateFilterMaxIndex;

      const $newRow = $composer.clone(false);
      $newRow.removeClass("mass-update-filter-row-composer");
      $newRow.attr("data-row-index", String(newIx));
      $newRow.find("select.mass-update-filter-field").val(fieldVal);
      $newRow.find("input[type='text']").val(textVal);
      $newRow.find("[name]").each(function () {
        const $el = $(this);
        const name = $el.attr("name");
        if (name && name.includes("mass_update_filters[")) {
          $el.attr("name", name.replace(/mass_update_filters\[\d+\]/, `mass_update_filters[${newIx}]`));
        }
      });
      const removeBtn = $(
        '<button type="button" class="sn-transparent-btn mass-update-remove-filter" title="Remove filter" aria-label="Remove filter">' +
          '<i class="fa fa-times fa-lg text-danger"></i>' +
          "</button>"
      );
      $newRow.find(".mass-update-filter-actions").empty().append(removeBtn);
      $rows.append($newRow);

      $select.val("");
      $text.val("");
    });

    $(document).on("click", `${modal} .mass-update-remove-filter`, function (e) {
      e.preventDefault();
      const $rows = $("#mass-update-filter-rows");
      const $row = $(this).closest(".mass-update-filter-row");
      if ($row.hasClass("mass-update-filter-row-composer")) {
        $row.find("select, input[type='text']").val("");
        return;
      }
      $row.remove();
    });

    $(document).on("submit", form, (e) => {
      const $form = $(form);
      const minOn = $form.find("#rt_mass_update_min_toggle").is(":checked");
      const maxOn = $form.find("#rt_mass_update_max_toggle").is(":checked");
      const msg = ($form.data("minMaxMessage") as string) || "";
      this.clearModalErrors(this.massUpdateModalSelector);

      if (!minOn && !maxOn) {
        e.preventDefault();
        this.showSummaryError(msg, this.massUpdateModalSelector);
        return;
      }
      if (minOn && String($form.find("#rt_mass_update_min").val() || "").trim() === "") {
        e.preventDefault();
        this.showFieldError("#rt_mass_update_min", msg, this.massUpdateModalSelector);
        return;
      }
      if (maxOn && String($form.find("#rt_mass_update_max").val() || "").trim() === "") {
        e.preventDefault();
        this.showFieldError("#rt_mass_update_max", msg, this.massUpdateModalSelector);
        return;
      }
    });
  }

  private bindAutoUpdateRules(): void {
    const modal = this.autoUpdateRulesModalSelector;

    $(document).on("change", `${modal} .rt-auto-update-rule-toggle`, function (this: HTMLElement) {
      const targetId = $(this).data("target") as string;
      $(`#${targetId}`).prop("disabled", !$(this).is(":checked"));
    });

    $(document).on(
      "input change",
      `${modal} .auto-update-rule-condition-row-composer select, ${modal} .auto-update-rule-condition-row-composer input`,
      () => this.refreshAutoUpdateRuleButtons()
    );

    $(document).on("input", `${modal} #rt_auto_update_rule_name`, () => this.refreshAutoUpdateRuleButtons());

    $(document).on("click", `${modal} .auto-update-rule-add-condition`, (e) => {
      e.preventDefault();
      const $composer = $(`${modal} .auto-update-rule-condition-row-composer`).first();
      if (!$composer.length) {
        return;
      }

      const field = String($composer.find("select.auto-update-rule-condition-field").val() || "").trim();
      const criteria = String($composer.find("select.auto-update-rule-condition-criteria").val() || "").trim();
      const value = String($composer.find("input.auto-update-rule-condition-value").val() || "").trim();

      if (!field || !criteria || !value) {
        return;
      }

      this.appendAutoUpdateRuleCondition(field, criteria, value);
      this.resetAutoUpdateRuleComposer();
    });

    $(document).on("click", `${modal} .auto-update-rule-remove-condition`, (e) => {
      e.preventDefault();
      $(e.currentTarget).closest(".auto-update-rule-condition-row").remove();
      this.refreshAutoUpdateRuleButtons();
    });

    $(document).on("click", `${modal} .auto-update-rule-clear`, (e) => {
      e.preventDefault();
      this.resetAutoUpdateRuleForm();
    });

    $(document).on("click", `${modal} .auto-update-rule-add`, (e) => {
      e.preventDefault();
      this.submitAutoUpdateRule();
    });

    $(document).on("click", `${modal} .auto-update-rule-edit`, (e) => {
      e.preventDefault();
      this.loadAutoUpdateRuleIntoForm($(e.currentTarget).closest(".auto-update-rule-row"));
    });

    $(document).on("click", `${modal} .auto-update-rule-delete`, (e) => {
      e.preventDefault();
      const $row = $(e.currentTarget).closest(".auto-update-rule-row");
      const $body = $(`${modal} .modal-body`);

      swal({
        title: String($body.data("deleteConfirmTitle") || ""),
        text: String($body.data("deleteConfirm") || ""),
        icon: "warning",
        closeOnClickOutside: false,
        className: "sn-m-modal",
        buttons: {
          cancel: {
            text: String($body.data("cancelLabel") || "No"),
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
          },
          confirm: {
            text: String($body.data("confirmLabel") || "Yes"),
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true
          }
        },
        dangerMode: true
      }).then((confirmed: boolean) => {
        if (!confirmed) {
          return;
        }
        this.sendAutoUpdateRuleRequest(String($row.data("deleteUrl")), "DELETE", {});
      });
    });

    $(document).on("click", `${modal} .auto-update-rule-toggle`, (e) => {
      e.preventDefault();
      const $row = $(e.currentTarget).closest(".auto-update-rule-row");
      this.sendAutoUpdateRuleRequest(String($row.data("toggleUrl")), "POST", {});
    });

    $(document).on("input change", ".sn-field-error", function (this: HTMLElement) {
      $(this).removeClass("sn-field-error").next(".sn-inline-field-error").remove();
    });

    this.initAutoUpdateRulesSortable();
    $(modal).on("shown.bs.modal", () => {
      this.initAutoUpdateRulesSortable();
      this.refreshAutoUpdateRuleButtons();
    });
    $(modal).on("hidden.bs.modal", () => this.resetAutoUpdateRuleForm());
  }

  private refreshAutoUpdateRuleButtons(): void {
    const modal = this.autoUpdateRulesModalSelector;
    const $composer = $(`${modal} .auto-update-rule-condition-row-composer`).first();
    if (!$composer.length) {
      return;
    }

    const field = String($composer.find("select.auto-update-rule-condition-field").val() || "").trim();
    const criteria = String($composer.find("select.auto-update-rule-condition-criteria").val() || "").trim();
    const value = String($composer.find("input.auto-update-rule-condition-value").val() || "").trim();
    const composerComplete = Boolean(field && criteria && value);

    $composer.find(".auto-update-rule-add-condition").prop("disabled", !composerComplete);

    const name = String($(`${modal} #rt_auto_update_rule_name`).val() || "").trim();
    const addedConditions = $(`${modal} .auto-update-rule-condition-row`)
      .not(".auto-update-rule-condition-row-composer").length;
    const editingDefault = $(`${modal} #auto-update-rule-default-note`).is(":visible");
    const hasConditions = editingDefault || addedConditions > 0 || composerComplete;

    $(`${modal} .auto-update-rule-add`).prop("disabled", !(name && hasConditions));
  }

  private appendAutoUpdateRuleCondition(field: string, criteria: string, value: string): void {
    const modal = this.autoUpdateRulesModalSelector;
    const $rows = $("#auto-update-rule-condition-rows");
    const $composer = $rows.find(".auto-update-rule-condition-row-composer").first();

    this.autoUpdateRuleConditionMaxIndex += 1;
    const newIx = this.autoUpdateRuleConditionMaxIndex;

    const $newRow = $composer.clone(false);
    $newRow.removeClass("auto-update-rule-condition-row-composer");
    $newRow.attr("data-row-index", String(newIx));
    $newRow.find("select.auto-update-rule-condition-field").val(field);
    $newRow.find("select.auto-update-rule-condition-criteria").val(criteria);
    $newRow.find("input.auto-update-rule-condition-value").val(value);
    $newRow.find("[name]").each(function () {
      const $el = $(this);
      const name = $el.attr("name");
      if (name && name.includes("auto_update_rule_conditions[")) {
        $el.attr("name", name.replace(/auto_update_rule_conditions\[\d+\]/, `auto_update_rule_conditions[${newIx}]`));
      }
    });
    const removeBtn = $(
      '<button type="button" class="sn-transparent-btn auto-update-rule-remove-condition" title="Remove condition" aria-label="Remove condition">' +
        '<i class="fa fa-minus-circle text-danger" style="font-size: 1.7em;"></i>' +
        "</button>"
    );
    $newRow.find(".auto-update-rule-condition-actions").empty().append(removeBtn);
    $(`${modal} #auto-update-rule-condition-rows`).append($newRow);
  }

  private collectAutoUpdateRuleConditions(): Array<Record<string, string>> {
    const modal = this.autoUpdateRulesModalSelector;
    const conditions: Array<Record<string, string>> = [];

    $(`${modal} .auto-update-rule-condition-row`)
      .not(".auto-update-rule-condition-row-composer")
      .each(function () {
        const $row = $(this);
        const field = String($row.find("select.auto-update-rule-condition-field").val() || "").trim();
        const criteria = String($row.find("select.auto-update-rule-condition-criteria").val() || "").trim();
        const value = String($row.find("input.auto-update-rule-condition-value").val() || "").trim();
        if (field && criteria && value) {
          conditions.push({ field: field, criteria: criteria, value: value });
        }
      });

    return conditions;
  }

  private clearModalErrors(modal: string): void {
    $(`${modal} .sn-field-error`).removeClass("sn-field-error");
    $(`${modal} .sn-inline-field-error`).remove();
    $(`${modal} .sn-error-summary`).hide().text("");
  }

  private clearAutoUpdateRuleErrors(): void {
    this.clearModalErrors(this.autoUpdateRulesModalSelector);
  }

  private showFieldError(selector: string, message: string, modal: string): void {
    const $field = $(selector);
    if (!$field.length) {
      this.showSummaryError(message, modal);
      return;
    }

    $field.addClass("sn-field-error");
    if (!$field.next(".sn-inline-field-error").length) {
      $field.after($('<p class="sn-field-error-message sn-inline-field-error"></p>').text(message));
    }
  }

  private showSummaryError(message: string, modal: string): void {
    const $summary = $(`${modal} .sn-error-summary`);
    const existing = String($summary.text() || "").trim();
    $summary.text(existing ? `${existing} ${message}` : message).show();
  }

  private showAutoUpdateRuleFieldError(selector: string, message: string): void {
    this.showFieldError(selector, message, this.autoUpdateRulesModalSelector);
  }

  private showAutoUpdateRuleSummaryError(message: string): void {
    this.showSummaryError(message, this.autoUpdateRulesModalSelector);
  }

  private showAutoUpdateRuleErrors(errors: Record<string, string[]>): void {
    const fieldSelectors: Record<string, string> = {
      name: "#rt_auto_update_rule_name",
      min_value: "#rt_auto_update_rule_min",
      max_value: "#rt_auto_update_rule_max"
    };

    Object.keys(errors).forEach((key) => {
      const messages = errors[key] || [];
      if (!messages.length) {
        return;
      }

      const selector = fieldSelectors[key];
      if (selector) {
        this.showAutoUpdateRuleFieldError(selector, messages[0]);
      } else {
        messages.forEach((message) => this.showAutoUpdateRuleSummaryError(message));
      }
    });
  }

  private submitAutoUpdateRule(): void {
    const modal = this.autoUpdateRulesModalSelector;
    this.clearAutoUpdateRuleErrors();
    const $composer = $(`${modal} .auto-update-rule-condition-row-composer`).first();
    const pendingField = String($composer.find("select.auto-update-rule-condition-field").val() || "").trim();
    const pendingCriteria = String($composer.find("select.auto-update-rule-condition-criteria").val() || "").trim();
    const pendingValue = String($composer.find("input.auto-update-rule-condition-value").val() || "").trim();
    if (pendingField && pendingCriteria && pendingValue) {
      this.appendAutoUpdateRuleCondition(pendingField, pendingCriteria, pendingValue);
      this.resetAutoUpdateRuleComposer();
    }

    const ruleId = String($("#rt_auto_update_rule_id").val() || "").trim();
    const $row = ruleId ? $(`#auto-update-rule-${ruleId}`) : $();
    const url = ruleId
      ? String($row.data("updateUrl"))
      : String($(`${modal} .modal-body`).data("createUrl"));

    const name = String($("#rt_auto_update_rule_name").val() || "").trim();
    if (!name) {
      this.showAutoUpdateRuleFieldError("#rt_auto_update_rule_name", this.autoUpdateRuleNameRequiredMessage());
      return;
    }

    const payload = {
      name: name,
      update_min: $("#rt_auto_update_rule_min_toggle").is(":checked") ? "1" : "0",
      min_value: String($("#rt_auto_update_rule_min").val() || ""),
      update_max: $("#rt_auto_update_rule_max_toggle").is(":checked") ? "1" : "0",
      max_value: String($("#rt_auto_update_rule_max").val() || ""),
      conditions: this.collectAutoUpdateRuleConditions()
    };

    $(`${modal} .auto-update-rule-add`).prop("disabled", true);
    const request = this.sendAutoUpdateRuleRequest(url, ruleId ? "PATCH" : "POST", payload);
    if (request) {
      request.always(() => this.refreshAutoUpdateRuleButtons());
    } else {
      this.refreshAutoUpdateRuleButtons();
    }
  }

  private loadAutoUpdateRuleIntoForm($row: JQuery<HTMLElement>): void {
    if (!$row.length) {
      return;
    }

    this.resetAutoUpdateRuleForm();

    $("#rt_auto_update_rule_id").val(String($row.data("ruleId")));
    $("#rt_auto_update_rule_name").val(String($row.data("name") || ""));

    const minValue = String($row.data("minValue") ?? "");
    const maxValue = String($row.data("maxValue") ?? "");
    $("#rt_auto_update_rule_min_toggle").prop("checked", minValue !== "").trigger("change");
    $("#rt_auto_update_rule_max_toggle").prop("checked", maxValue !== "").trigger("change");
    $("#rt_auto_update_rule_min").val(minValue);
    $("#rt_auto_update_rule_max").val(maxValue);

    const raw = $row.attr("data-conditions") || "[]";
    let conditions: Array<Record<string, string>> = [];
    try {
      conditions = JSON.parse(raw);
    } catch (err) {
      conditions = [];
    }
    conditions.forEach((condition) => {
      this.appendAutoUpdateRuleCondition(condition.field, condition.criteria, condition.value);
    });

    const isDefault = String($row.data("isDefault") || "0") === "1";
    $("#auto-update-rule-conditions-section").toggle(!isDefault);
    $("#auto-update-rule-default-note").toggle(isDefault);

    const $btn = $(`${this.autoUpdateRulesModalSelector} .auto-update-rule-add`);
    $btn.text(String($btn.data("saveLabel") || $btn.text()));
    this.refreshAutoUpdateRuleButtons();
  }

  private autoUpdateRuleNameRequiredMessage(): string {
    return String($("#rt_auto_update_rule_name").data("requiredMessage") || "Rule Name can't be blank");
  }

  private resetAutoUpdateRuleForm(): void {
    const modal = this.autoUpdateRulesModalSelector;
    this.clearAutoUpdateRuleErrors();
    const $rows = $(`${modal} #auto-update-rule-condition-rows`);

    $rows.find(".auto-update-rule-condition-row").not(".auto-update-rule-condition-row-composer").remove();
    this.resetAutoUpdateRuleComposer();
    this.autoUpdateRuleConditionMaxIndex = 0;

    $("#auto-update-rule-conditions-section").show();
    $("#auto-update-rule-default-note").hide();

    $("#rt_auto_update_rule_id").val("");
    $("#rt_auto_update_rule_name").val("");
    $("#rt_auto_update_rule_min_toggle").prop("checked", true).trigger("change");
    $("#rt_auto_update_rule_max_toggle").prop("checked", true).trigger("change");
    $("#rt_auto_update_rule_min").val("1");
    $("#rt_auto_update_rule_max").val("5");

    const $btn = $(`${modal} .auto-update-rule-add`);
    $btn.text(String($btn.data("addLabel") || $btn.text()));
  }

  private resetAutoUpdateRuleComposer(): void {
    const $composer = $(`${this.autoUpdateRulesModalSelector} .auto-update-rule-condition-row-composer`).first();
    $composer.find("select.auto-update-rule-condition-field").val("");
    $composer.find("input.auto-update-rule-condition-value").val("");
    $composer.find("select.auto-update-rule-condition-criteria").val(this.autoUpdateRuleDefaultCriteria);
    this.refreshAutoUpdateRuleButtons();
  }

  private initAutoUpdateRulesSortable(): void {
    const $tbody = $("#auto-update-rules-rows");
    if (!$tbody.length) {
      return;
    }
    if ($tbody.hasClass("ui-sortable")) {
      $tbody.sortable("destroy");
    }
    $tbody.sortable({
      items: "tr.auto-update-rule-row:not(.auto-update-rule-default)",
      cancel: "a, button, input, select, textarea",
      axis: "y",
      cursor: "move",
      opacity: 0.85,
      tolerance: "pointer",
      sort: () => {
        const $default = $tbody.find("tr.auto-update-rule-default");
        if ($default.length && !$default.is(":last-child")) {
          $tbody.append($default);
        }
      },
      helper: (_e: JQuery.Event, ui: JQuery<HTMLElement>) => {
        ui.children().each(function () {
          $(this).width($(this).width() || 0);
        });
        return ui;
      },
      update: () => {
        const ids = $tbody
          .find("tr.auto-update-rule-row")
          .not(".auto-update-rule-default")
          .map((_ix: number, el: HTMLElement) => String($(el).data("ruleId")))
          .get()
          .filter((id: string) => !!id);
        const url = String($(`${this.autoUpdateRulesModalSelector} .modal-body`).data("reorderUrl"));
        this.postAutoUpdateRules(url, "POST", { ids: ids }).done(() => this.renumberAutoUpdateRulePriorities());
      }
    });
  }

  private renumberAutoUpdateRulePriorities(): void {
    $(`${this.autoUpdateRulesModalSelector} tr.auto-update-rule-row`)
      .not(".auto-update-rule-default")
      .each(function (index: number) {
        $(this).children("td").first().text(String(index + 1));
      });
  }

  private postAutoUpdateRules(url: string, method: string, payload: Record<string, unknown>): JQuery.jqXHR {
    return $.ajax({
      url: url,
      type: method,
      dataType: "json",
      data: payload,
      headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr("content") || "" }
    });
  }

  private sendAutoUpdateRuleRequest(
    url: string,
    method: string,
    payload: Record<string, unknown>
  ): JQuery.jqXHR | null {
    if (!url) {
      return null;
    }

    return this.postAutoUpdateRules(url, method, payload)
      .done((response: { html?: string }) => {
        this.replaceAutoUpdateRulesTable(response && response.html);
        this.resetAutoUpdateRuleForm();
      })
      .fail((xhr: JQuery.jqXHR) => {
        const response = (xhr.responseJSON || {}) as {
          html?: string;
          message?: string;
          errors?: Record<string, string[]>;
        };
        this.replaceAutoUpdateRulesTable(response.html);
        if (response.errors && Object.keys(response.errors).length) {
          this.showAutoUpdateRuleErrors(response.errors);
        } else if (response.message) {
          this.showAutoUpdateRuleSummaryError(response.message);
        }
      });
  }

  private replaceAutoUpdateRulesTable(html?: string): void {
    if (!html) {
      return;
    }
    $(`${this.autoUpdateRulesModalSelector} #auto-update-rules-table-wrapper`).replaceWith(html);
    this.initAutoUpdateRulesSortable();
  }
}

export function LoadPage(): void {
  InitPageStrict("replenishment_templates show", () => {
    new ReplenishmentTemplatesShow();
  });
}
